import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import { MediaType } from '../MediaType';

export const experimentalContentBodyConvert: ExperimentalQueries['experimentalContentBodyConvert'] =
	(
		_,
		{ body, from, to, expand, spaceKeyContext, contentIdContext, embeddedContentRender },
		{ network },
	) => {
		const requestBody = {
			representation: from,
			value: body,
		};

		const params = new URLSearchParams();
		if (expand) {
			params.append('expand', expand.join(','));
		}
		if (spaceKeyContext) {
			params.append('spaceKeyContext', spaceKeyContext);
		}
		if (contentIdContext) {
			params.append('contentIdContext', contentIdContext);
		}
		if (embeddedContentRender) {
			params.append('embeddedContentRender', embeddedContentRender);
		}
		return network
			.cfetch(`/wiki/rest/api/contentbody/convert/${to}?${params}`, {
				method: 'POST',
				body: JSON.stringify(requestBody),
				credentials: 'include',
				headers: {
					'Content-Type': MediaType.JSON,
				},
			})
			.then(async (response) => {
				if (response.ok && response.status === 200) {
					const responseBody = await response.json();

					return {
						value: responseBody.value,
					};
				}

				throw response;
			})
			.catch((error) => {
				throw Error(
					`Conversion HTTP error, status = ${error.status}, message = "${error.statusText}"`,
				);
			});
	};
